export const SYSTEM_EVENTS = {
    hello: 'system:hello',
    welcome: 'system:welcome',
    rejected: 'system:rejected',
    overlayPresence: 'system:overlay-presence',
};
//# sourceMappingURL=system.js.map